export default __webpack_public_path__ + "static/media/grab.37b51446.svg";